
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M19 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1H8V1c0-.55-.45-1-1-1S6 .45 6 1v1H5C2.24 2 0 4.24 0 7v12c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5zm-8 7v3H8V9h3zm5 0v3h-3V9h3zm6 0v3h-4V9h4zM6 12H2V9h4v3zm-4 2h4v3H2v-3zm6 0h3v3H8v-3zm3 5v3H8v-3h3zm2 0h3v3h-3v-3zm0-2v-3h3v3h-3zm5-3h4v3h-4v-3zM5 4h14c1.65 0 3 1.35 3 3H2c0-1.65 1.35-3 3-3zM2 19h4v3H5c-1.65 0-3-1.35-3-3zm17 3h-1v-3h4c0 1.65-1.35 3-3 3z"}})])
          )
        }
      }
    